module.exports = __webpack_public_path__ + "img/y_p3_yun.cc3c167a.svg";